__webpack_require__.p = "https://apollo-uat.cardlink.gr/";